export default __webpack_public_path__ + "static/banner-m-6052eb6a16bd0bd4e4e847954a529703.png";